import react from "../img/project/react.png";
import livewire from "../img/project/livewire.png";
import next from "../img/project/nex2.png";
import laravel from "../img/project/laravel2.png";

export const data = [
  {
    id: 1,
    name: "React JS Application",
    image: react,
    github: "https://github.com/itiwariarun/Food-Cart",
    live: "works",
  },
  {
    id: 2,
    name: "Next JS Application",
    image: next,
    github: "https://github.com/itiwariarun/Next.js-BLOG",
    live: "works",
  },
  {
    id: 3,
    name: "Livewire Application",
    image: livewire,
    github: "https://github.com/itiwariarun/GLH",
    live: "works",
  },
  {
    id: 4,
    name: "Laravel Application",
    image: laravel,
    github: "https://github.com/itiwariarun/Blog",
    live: "works",
  },
];
